import { render, staticRenderFns } from "./holidayActFemaleRules.vue?vue&type=template&id=e20925ce&scoped=true"
import script from "./holidayActFemaleRules.vue?vue&type=script&lang=js"
export * from "./holidayActFemaleRules.vue?vue&type=script&lang=js"
import style0 from "./holidayActFemaleRules.vue?vue&type=style&index=0&id=e20925ce&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e20925ce",
  null
  
)

export default component.exports